import { differenceInMilliseconds, isBefore, isEqual } from 'date-fns'
import { oneHour } from '../../utils/date'

export type ValidateWorkPeriodTheoreticalRangeResult = {
  startDate?: string
  endDate?: string
}

/**
 * Validates theoretical start/end range for a work period.
 * Rules: start and end required, end must be after start (date-aware), duration <= 24h.
 * Overnight shifts (e.g. 20:00 on day 2 to 05:00 on day 3) are valid.
 *
 * @param start - Theoretical start date/time (or undefined if missing).
 * @param end - Theoretical end date/time (or undefined if missing).
 * @returns Object with optional startDate/endDate error messages.
 */
export function validateWorkPeriodTheoreticalRange(
  start: Date | undefined,
  end: Date | undefined,
): ValidateWorkPeriodTheoreticalRangeResult {
  const result: ValidateWorkPeriodTheoreticalRangeResult = {}

  if (start === undefined || start === null) {
    result.startDate = "L'heure de début n'est pas précisée"
  }
  if (end === undefined || end === null) {
    result.endDate = "L'heure de fin n'est pas précisée"
  }

  if (start && end) {
    if (isEqual(end, start) || isBefore(end, start)) {
      result.endDate = "L'heure de fin doit être après l'heure de début"
    } else if (differenceInMilliseconds(end, start) > 24 * oneHour) {
      result.endDate = 'La période ne peut pas dépasser 24 heures'
    }
  }

  return result
}
